/** Il nome del ruolo nello spazio attivo, per il riquadro: le stesse voci della barra in alto. */
const CHIAVI_RUOLO = {
  TITOLARE: "t-ruolo-titolare",
  AMMINISTRATORE: "t-ruolo-amministratore",
  COLLABORATORE: "t-ruolo-collaboratore",
  GOVERNANTE: "t-ruolo-governante",
  PROPRIETARIO: "t-ruolo-proprietario",
};

/**
 * Il gestionale: quello che vede chiunque. Il menu resta components/menu.vue, che dipende dai ruoli
 * e dalle funzioni dello spazio: qui non si dichiara `menu`, ed è così che il layout lo capisce.
 */
export default {
  id: "zoelia",
  label: "Zoelia",
  icon: "ri-home-4-line",
  color: "primary",
  description: "Prenotazioni, calendario, messaggi e check-in delle strutture.",
  // A / la guardia del ruolo porta da sola chi non vede il cruscotto alla sua pagina iniziale.
  home: "/",
  canAccess: () => true,
  roleLabel: (profilo, t) => (CHIAVI_RUOLO[profilo?.ruolo] ? t(CHIAVI_RUOLO[profilo.ruolo]) : ""),
};
